import { createSelector } from 'reselect';
import { HAS_SEEN_DEAL_STAGE_FORECAST_TOUR, HAS_SEEN_FMO_MIGRATION_TOUR } from '../constants/SettingsTypes';
// @ts-expect-error untyped import
import { decodeSettingsValue } from 'crm_data/settings/UserSettingsSerialization';
import { SUCCEEDED } from '../constants/RequestStatusTypes';
export const getDisplayOptions = state => state.displayOptions;

/*
 *  For all getHasSeen*Tour Selectors
 *     If displayOptions['status'] is not SUCCEEDED
 *       We assume the user has seen the tour (to avoid repeatedly showing extra tours)!
 */

export const getHasSeenDealStageForecastTour = createSelector([getDisplayOptions], displayOptions => {
  return displayOptions.get('status') !== SUCCEEDED || decodeSettingsValue(displayOptions.get(HAS_SEEN_DEAL_STAGE_FORECAST_TOUR));
});
export const getHasSeenFmoMigrationTour = createSelector([getDisplayOptions], displayOptions => {
  return displayOptions.get('status') !== SUCCEEDED || decodeSettingsValue(displayOptions.get(HAS_SEEN_FMO_MIGRATION_TOUR));
});